<mat-expansion-panel [className]="hasError ? 'mat-expansion-panel error-class' : 'mat-expansion-panel'" >
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{title | translate}}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <ng-content></ng-content>
</mat-expansion-panel>
